/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecurringTaskInstanceDto
 */
export interface RecurringTaskInstanceDto {
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    scheduleBlockId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    definitionId?: string;
    /**
     * 
     * @type {number}
     * @memberof RecurringTaskInstanceDto
     */
    definitionVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    cadenceTier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecurringTaskInstanceDto
     */
    evidenceRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    outcome?: string;
    /**
     * 
     * @type {number}
     * @memberof RecurringTaskInstanceDto
     */
    taskScore?: number;
    /**
     * 
     * @type {number}
     * @memberof RecurringTaskInstanceDto
     */
    evidenceCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecurringTaskInstanceDto
     */
    findingsUnresolved?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskInstanceDto
     */
    completedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    completedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    completionNotes?: string;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskInstanceDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskInstanceDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskInstanceDto
     */
    scheduledFor?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecurringTaskInstanceDto
     */
    dueAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof RecurringTaskInstanceDto
     */
    blockStatus?: string;
}

/**
 * Check if a given object implements the RecurringTaskInstanceDto interface.
 */
export function instanceOfRecurringTaskInstanceDto(value: object): value is RecurringTaskInstanceDto {
    return true;
}

export function RecurringTaskInstanceDtoFromJSON(json: any): RecurringTaskInstanceDto {
    return RecurringTaskInstanceDtoFromJSONTyped(json, false);
}

export function RecurringTaskInstanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringTaskInstanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'scheduleBlockId': json['scheduleBlockId'] == null ? undefined : json['scheduleBlockId'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'definitionVersion': json['definitionVersion'] == null ? undefined : json['definitionVersion'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'cadenceTier': json['cadenceTier'] == null ? undefined : json['cadenceTier'],
        'evidenceRequired': json['evidenceRequired'] == null ? undefined : json['evidenceRequired'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'taskScore': json['taskScore'] == null ? undefined : json['taskScore'],
        'evidenceCount': json['evidenceCount'] == null ? undefined : json['evidenceCount'],
        'findingsUnresolved': json['findingsUnresolved'] == null ? undefined : json['findingsUnresolved'],
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'completedBy': json['completedBy'] == null ? undefined : json['completedBy'],
        'completionNotes': json['completionNotes'] == null ? undefined : json['completionNotes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'scheduledFor': json['scheduledFor'] == null ? undefined : (new Date(json['scheduledFor'])),
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'blockStatus': json['blockStatus'] == null ? undefined : json['blockStatus'],
    };
}

export function RecurringTaskInstanceDtoToJSON(json: any): RecurringTaskInstanceDto {
    return RecurringTaskInstanceDtoToJSONTyped(json, false);
}

export function RecurringTaskInstanceDtoToJSONTyped(value?: RecurringTaskInstanceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'scheduleBlockId': value['scheduleBlockId'],
        'definitionId': value['definitionId'],
        'definitionVersion': value['definitionVersion'],
        'initiativeId': value['initiativeId'],
        'dimensionId': value['dimensionId'],
        'cadenceTier': value['cadenceTier'],
        'evidenceRequired': value['evidenceRequired'],
        'outcome': value['outcome'],
        'taskScore': value['taskScore'],
        'evidenceCount': value['evidenceCount'],
        'findingsUnresolved': value['findingsUnresolved'],
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'completedBy': value['completedBy'],
        'completionNotes': value['completionNotes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'scheduledFor': value['scheduledFor'] == null ? undefined : ((value['scheduledFor']).toISOString()),
        'dueAt': value['dueAt'] == null ? undefined : ((value['dueAt']).toISOString()),
        'blockStatus': value['blockStatus'],
    };
}

